import axios from 'axios';
import { AXIOS_XHR_CONFIG } from 'react/shared/utils/Axios';

export function getConnectionsByTrustBeneficiary(trustBeneficiaryId) {
  return axios.get(
    RailsRoutes.dashboard_client_connections_path(trustBeneficiaryId, { format: 'json' }),
    AXIOS_XHR_CONFIG,
  );
}
